import { ReactNode } from "react";
import { Colors } from "main";

export type LogInButtonProps = {
  /**
   * @description  Determines the type of  button
   * @default "filled"
   * @prop "filled" -- button with background (blue 500)
   * @prop "outlined" -- no background (transparent)
   */
  variant?: "outlined" | "filled";
  /**
   * When true, the button will be 100% width
   * @default false
   */
  isFluid?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  hasShadow?: boolean;
  children: ReactNode;
};

export function LogInButton(props: LogInButtonProps) {
  const { variant = "contained", isFluid, disabled, hasShadow, onClick, children } = props;

  const isOutlined = variant === "outlined";

  return (
    <button
      css={{
        fontWeight: 600,
        cursor: "pointer",
        background: isOutlined ? "transparent" : Colors.blue500,
        padding: 8,
        color: isOutlined ? Colors.blue500 : Colors.white200,
        borderRadius: 30,
        "&:disabled": {
          background: Colors.slate200,
          color: Colors.slate400,
          border: `2px solid ${Colors.slate200}`,
        },
        // optional styles
        ...(isFluid && {
          width: "100%",
        }),
        ...(hasShadow && {
          boxShadow: "0px 2px 4px 0px rgba(40, 60, 93, 0.16)",
        }),
        ...(isOutlined && {
          border: `2px solid ${Colors.blue500}`,
        }),
      }}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
